import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, AlertCircle, ArrowRight, Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";
import Header from "../components/Header";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const VerifyEmail = () => {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState("pending"); // pending | ok | error
  const [error, setError] = useState("");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setError(t("verifyEmail.missingToken"));
      return;
    }
    (async () => {
      try {
        await axios.post(`${API}/auth/password/verify-email`, { token });
        setStatus("ok");
      } catch (err) {
        setStatus("error");
        setError(
          err?.response?.data?.detail ||
            t("verifyEmail.invalid")
        );
      }
    })();
  }, [token, t]);

  return (
    <div className="relative min-h-screen trubeaute-gradient">
      <Header />
      <section
        className="pt-32 pb-24 px-6 flex items-center justify-center min-h-[90vh]"
        data-testid="verify-root"
      >
        <div className="max-w-md w-full">
          <div className="bg-white border border-[#EADDD7] rounded-3xl p-10 text-center soft-shadow-lg">
            <div className="h-14 w-14 rounded-full bg-gradient-to-br from-[#D5A8A4] to-[#9B6A6C] flex items-center justify-center mb-6 soft-shadow mx-auto">
              <Sparkles className="h-6 w-6 text-white" />
            </div>
            {status === "pending" && (
              <div data-testid="verify-pending">
                <p className="text-[#5C4B51] leading-relaxed">
                  {t("verifyEmail.verifying")}
                </p>
              </div>
            )}
            {status === "ok" && (
              <div data-testid="verify-ok">
                <div className="mx-auto h-12 w-12 rounded-full bg-[#F2E8E9] flex items-center justify-center mb-4">
                  <CheckCircle2 className="h-6 w-6 text-[#9B6A6C]" />
                </div>
                <h1 className="font-serif italic text-3xl text-[#2C2123] mb-3 leading-tight">
                  {t("verifyEmail.okTitle")}
                </h1>
                <p className="text-[#5C4B51] mb-6 leading-relaxed">
                  {t("verifyEmail.okBody")}
                </p>
                <Link
                  to="/onboarding"
                  className="inline-flex items-center gap-1.5 bg-[#9B6A6C] text-white hover:bg-[#805557] rounded-full px-6 py-3 text-sm transition-colors"
                  data-testid="verify-continue-btn"
                >
                  {t("verifyEmail.okCta")}
                  <ArrowRight className="h-4 w-4" />
                </Link>
              </div>
            )}
            {status === "error" && (
              <div data-testid="verify-error">
                <div className="mx-auto h-12 w-12 rounded-full bg-[#FFF1F1] flex items-center justify-center mb-4">
                  <AlertCircle className="h-6 w-6 text-[#9B3A3A]" />
                </div>
                <h1 className="font-serif italic text-3xl text-[#2C2123] mb-3 leading-tight">
                  {t("verifyEmail.errorTitle")}
                </h1>
                <p className="text-[#5C4B51] mb-6 leading-relaxed">{error}</p>
                <Link
                  to="/login"
                  className="inline-flex items-center gap-1.5 bg-[#9B6A6C] text-white hover:bg-[#805557] rounded-full px-6 py-3 text-sm transition-colors"
                  data-testid="verify-back-btn"
                >
                  {t("verifyEmail.errorCta")}
                  <ArrowRight className="h-4 w-4" />
                </Link>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default VerifyEmail;
